import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { CashOutComponent } from './cash-out.component';
import { SelectRecipientsComponent } from './select-recipients/select-recipients.component';

@NgModule({
  declarations: [CashOutComponent, SelectRecipientsComponent],
  exports: [CashOutComponent],
  imports: [
    RouterModule.forChild([
      {
        path: 'transfer',
        component: CashOutComponent
      }
    ]),
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class CashOutModule {}
